/**
 * Tests which event is working for the current browser
 * original by David Walsh: http://davidwalsh.name/css-animation-callback
 *
 * @param {Object[]} eventItems - A list of events
 * @param {string} eventItems[].event - The name of the JS event
 * @param {string} eventItems[].property - The name of the CSS property
 * @returns {string} The event's name
 */
function findValidEvent(events) {
  const el = document.createElement('fakeelement');
  const event = events.find(({ property }) => el.style[property] !== undefined);

  return event.name;
}

/** The animation end event for the current browser */
export const animationEvent = findValidEvent([
  { property: 'animation', name: 'animationend' },
  { property: 'OAnimation', name: 'oAnimationEnd' },
  { property: 'MozAnimation', name: 'animationend' },
  { property: 'WebkitAnimation', name: 'webkitAnimationEnd' },
]);

/** The transition end event for the current browser */
export const transitionEvent = findValidEvent([
  { property: 'transition', name: 'transitionend' },
  { property: 'OTransition', name: 'oTransitionEnd' },
  { property: 'MozTransition', name: 'transitionend' },
  { property: 'WebkitTransition', name: 'webkitTransitionEnd' },
]);

/**
 *  Resolves when an event happens for an element
 *
 * @export
 * @param {HTMLElement} element - The element
 * @param {string} eventName - The name of the event
 * @returns {Promise}
 */
export function untilEvent(element, eventName) {
  return new Promise(resolve => {
    function finished(event) {
      element.removeEventListener(eventName, finished);
      resolve(event);
    }
    element.addEventListener(eventName, finished);
  });
}

/**
 * Resolves after an animation frame
 *
 * @export
 * @returns {Promise}
 */
export function animationFrame() {
  return new Promise(resolve => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });
}

/**
 * Resolves after time
 *
 * @export
 * @param {number} time
 * @returns {Promise}
 */
export function timeout(time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}
